<p-dialog [header]="isEditMode ? ('emailSettingTemplateDailog.editEmailTemplate' | transloco) : ('emailSettingTemplateDailog.createEmailTemplate' | transloco)" [(visible)]="displayDialog"
  [modal]="true" [style]="{width: '1200px'}" (onHide)="onCloseDialog()">

  <form class="mt-2 px-4 p-3" #emailSettingsForm="ngForm">
    @if (selectedEmailTemplate) {
      <!-- Header Section with Gradient Background -->
      <div class="bg-gradient text-white rounded-4  mb-4">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <i class="pi pi-envelope fs-3 me-2"></i>
            <span class="fs-4 fw-bold">{{ 'emailSettingTemplateDailog.modeEmailTemplate' | transloco: { mode: (isEditMode ? ('emailSettingTemplateDailog.edit' | transloco) : ('emailSettingTemplateDailog.create' | transloco)) } }}</span>
          </div>
          <div class="d-flex gap-2">
            <button type="button" pButton class="p-button-outlined p-button-secondary p-button-rounded"
              (click)="showEmailLogDailog()" [disabled]="!selectedEmailTemplate.HtmlText">
              <i class="pi pi-eye me-2"></i> {{ 'emailSettingTemplateDailog.preview' | transloco }}
            </button>
            <button type="button" pButton icon="pi pi-save" [label]="'emailSettingTemplateDailog.saveChanges' | transloco"
              class="p-button-success p-button-outlined p-button-rounded" (click)="saveEmailTemplate($event)"
              [disabled]="emailSettingsForm.invalid">
            </button>
          </div>
        </div>
      </div>
      <!-- Main Content -->
      <div class="row g-3 ">
        <div class="col-lg-8">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-light border-0 rounded-top">
              <h6 class="mb-0 text-dark">
                <i class="fa fa-cog me-2"></i>{{ 'emailSettingTemplateDailog.emailConfiguration' | transloco }}
              </h6>
            </div>
            <div class="card-body p-3">
              <label class="form-label fw-bold" for="emailEvntDropdown">
                <i class="fa fa-calendar-alt me-2 text-dark"></i>
                <span class="text-danger">*</span> {{ 'emailSettingTemplateDailog.emailEvent' | transloco }}
              </label>
              <div class="d-flex align-items-center gap-2">
                <p-dropdown [(ngModel)]="selectedEmailTemplate.EmailEventId" [disabled]="isEditMode" [filter]="true"
                  [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'" [options]="emailEvents"
                  name="emailEvntDropdown" id="emailEvntDropdown" [placeholder]="'emailSettingTemplateDailog.selectEvent' | transloco"
                  (onChange)="onEmailEventChanged($event)" [required]="true" class="flex-grow-1">
                </p-dropdown>
                <p-button type="button" icon="fa fa-plus" [pTooltip]="'emailSettingTemplateDailog.addNewEmailEvent' | transloco"
                  class="p-button-outlined p-button-primary p-button-rounded" (click)="onAddEmailEvents()">
                </p-button>
                <div class="form-check d-flex align-items-center">
                  <p-checkbox [(ngModel)]="selectedEmailTemplate.IsSendToBccEmail" name="IsSendToBccEmail"
                    [binary]="true" inputId="bccCheckbox" [pTooltip]="'emailSettingTemplateDailog.sendToBccRecipients' | transloco">
                  </p-checkbox>
                  <label for="bccCheckbox" class="form-check-label ms-2 mt-1">{{ 'emailSettingTemplateDailog.bcc' | transloco }}</label>
                </div>
              </div>
              <!-- <div class="alert alert-info mt-3 border-0 bg-info bg-opacity-10">
              <small class="text-info">
                <i class="fa fa-info-circle me-1"></i>
                {{selectedEmailEvent?.data}}
              </small>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-header bg-light border-0 rounded-top">
            <h6 class="mb-0 text-success">
              <i class="fa fa-code me-2"></i>{{ 'emailSettingTemplateDailog.emailParameters' | transloco }}
            </h6>
          </div>
          <div class="card-body p-3">
            @if (emailParameters.length > 0) {
              <div>
                <p class="text-muted small mb-2">{{ 'emailSettingTemplateDailog.clickParameterToCopy' | transloco }}</p>
                <div class="d-flex flex-wrap gap-2">
                  @for (param of emailParameters; track param) {
                    <span
                      class="badge bg-secondary bg-gradient rounded-pill px-3 py-2 cursor-pointer user-select-none"
                      (click)="copySelectedEmailParameters(param)" [title]="'emailSettingTemplateDailog.clickToCopy' | transloco">
                      <i class="fa fa-copy me-1"></i>{{ param.ParameterName }}
                    </span>
                  }
                </div>
              </div>
            }
            @if (emailParameters.length === 0) {
              <div class="text-center text-muted">
                <i class="fa fa-inbox fs-3 mb-2"></i>
                <p class="small">{{ 'emailSettingTemplateDailog.noParametersAvailable' | transloco }}</p>
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Parameter Metadata Panel -->
      @if (selectedEmailParameter && EmailParameterData) {
        <div class="col-12">
          <p-panel [header]="'emailSettingTemplateDailog.parameterMetadata' | transloco" [toggleable]="true" class="shadow-sm border-0">
            <ng-template pTemplate="header">
              <span class="text-dark fw-semibold">
                <i class="fa fa-tags me-2"></i>{{ 'emailSettingTemplateDailog.parameterMetadata' | transloco }}
              </span>
            </ng-template>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label fw-semibold" for="DescriptionEdit">
                  <i class="fa fa-info-circle me-1 text-info"></i>{{ 'emailSettingTemplateDailog.parameterDescription' | transloco }}
                </label>
                <input type="text" class="form-control form-control-lg" name="DescriptionEdit" id="DescriptionEdit"
                  [(ngModel)]="EmailParameterData.ParameterDescription"
                  [placeholder]="'emailSettingTemplateDailog.enterShortDescription' | transloco" />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-semibold" for="ParameterUsageEdit">
                    <i class="fa fa-question-circle me-1 text-warning"></i>{{ 'emailSettingTemplateDailog.howAndWhereToUse' | transloco }}
                  </label>
                  <textarea class="form-control" name="ParameterUsageEdit" id="ParameterUsageEdit" rows="3"
                    [(ngModel)]="EmailParameterData.ParameterUsage"
                  [placeholder]="'emailSettingTemplateDailog.provideUsageDetails' | transloco"></textarea>
                </div>
                <div class="col-12">
                  <button pButton icon="fa fa-save" [label]="'emailSettingTemplateDailog.saveParameterMetadata' | transloco"
                    class="p-button-outlined p-button-success p-button-rounded" (click)="saveEmailParameterField($event)">
                  </button>
                </div>
              </div>
            </p-panel>
          </div>
        }
      </div>
      <!-- COMMON: Subject and Email Editor -->
      <div class="row g-3 mt-2">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-header bg-light border-0 rounded-top">
              <h6 class="mb-0 text-dark">
                <i class="fa fa-edit me-2"></i>{{ 'emailSettingTemplateDailog.emailContent' | transloco }}
              </h6>
            </div>
            <div class="card-body p-3">
              <div class="mb-3">
                <label class="form-label fw-bold" for="subject">
                  <i class="fa fa-heading me-2 text-dark"></i>
                  <span class="text-danger">*</span> {{ 'emailSettingTemplateDailog.subject' | transloco }}
                </label>
                <input type="text" class="form-control form-control-lg" name="subject" id="subject" required
                  [(ngModel)]="selectedEmailTemplate.Subject" [placeholder]="'emailSettingTemplateDailog.enterSubject' | transloco" />
                  @if (!isEditMode) {
                    <div class="form-text text-muted">
                      <i class="fa fa-lightbulb me-1"></i>
                      {{ 'emailSettingTemplateDailog.conciseSubjectLine' | transloco }}
                    </div>
                  }
                </div>
                <div>
                  <label class="form-label fw-bold" for="emailEditor">
                    <i class="fa fa-code me-2 text-success"></i>{{ 'emailSettingTemplateDailog.emailContent' | transloco }}
                  </label>
                  <div class="rounded-3 p-1">
                    <angular-editor #emailEditor name="emailEditor" [(ngModel)]="selectedEmailTemplate.HtmlText"
                      [config]="editorConfig" class="border-0" [placeholder]="'emailSettingTemplateDailog.startDesigningEmail' | transloco"
                      (viewMode)="onViewModeChanged($event)">
                    </angular-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </form>
  </p-dialog>

  <p-sidebar [(visible)]="emailPreviewVisible" position="right" [style]="{'width': '1020px'}">
    <div class="p-3">
      @if (selectedEmailTemplate?.HtmlText) {
        <!-- Email Preview Section -->
        <div class="card border-0 shadow-sm mb-4">
          <div class="card-header bg-light border-0 rounded-top">
            <h6 class="mb-0 text-dark">
              <i class="fa fa-eye me-2"></i>{{ 'emailSettingTemplateDailog.emailPreview' | transloco }}
            </h6>
          </div>
          <div class="card-body p-3">
            <p class="text-muted small mb-3">
              <i class="fa fa-info-circle me-1"></i>
              {{ 'emailSettingTemplateDailog.previewDescription' | transloco }}
            </p>
            <div [innerHTML]="selectedEmailTemplate.HtmlText | safeHtml" class="border rounded-3 p-3"
            id="htmlCodePreview"></div>
          </div>
        </div>
        <!-- Test Email Section -->
        <div class="card border-0 shadow-sm mb-4">
          <div class="card-header bg-light border-0 rounded-top">
            <h6 class="mb-0 text-dark">
              <i class="fa fa-send me-2"></i>{{ 'emailSettingTemplateDailog.testEmail' | transloco }}
            </h6>
          </div>
          <div class="card-body p-3">
            <p class="text-muted small mb-3">
              <i class="fa fa-lightbulb me-1"></i>
              {{ 'emailSettingTemplateDailog.testEmailDescription' | transloco }}
            </p>
            <div class="row align-items-center g-2">
              <div class="col-9">
                <input type="email" class="form-control form-control-lg" name="email" id="email"
                  [placeholder]="'emailSettingTemplateDailog.emailPlaceholderExample' | transloco" [(ngModel)]="testEmailAddress"
                  [pTooltip]="'emailSettingTemplateDailog.enterValidEmailTooltip' | transloco" tooltipPosition="top" />
                </div>
                <div class="col-3">
                  <button type="button" pButton icon="fa fa-send" [label]="'emailSettingTemplateDailog.sendTestEmail' | transloco"
                    class="p-button-outlined p-button-primary p-button-rounded w-100" (click)="sendTestEmail($event)"
                    [pTooltip]="'emailSettingTemplateDailog.sendTestEmailTooltip' | transloco" tooltipPosition="top">
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Additional Help Section -->
          <div class="card border-0 shadow-sm">
            <div class="card-header bg-light border-0 rounded-top">
              <h6 class="mb-0 text-dark">
                <i class="fa fa-info-circle me-2"></i>{{ 'emailSettingTemplateDailog.tips' | transloco }}
              </h6>
            </div>
            <div class="card-body p-3">
              <ul class="text-muted small">
                <li><i class="fa fa-check me-1"></i>{{ 'emailSettingTemplateDailog.tipEmailValid' | transloco }}</li>
                <li><i class="fa fa-eye me-1"></i>{{ 'emailSettingTemplateDailog.tipReviewPreview' | transloco }}</li>
                <li><i class="fa fa-envelope me-1"></i>{{ 'emailSettingTemplateDailog.tipTestEmailClients' | transloco }}</li>
            </ul>
          </div>
        </div>
      }

      <!-- No Template Selected -->
      @if (!selectedEmailTemplate?.HtmlText) {
        <div class="alert alert-info border-0 bg-info bg-opacity-10 text-center p-4">
          <small class="text-info">
            <i class="fa fa-info-circle me-1"></i>
            {{ 'emailSettingTemplateDailog.noTemplateSelected' | transloco }}
          </small>
        </div>
      }
    </div>
  </p-sidebar>

  @if (isAddEmailEventDailogVisible) {
    <email-events-dailog [isAddEmailEventDailogVisible]="isAddEmailEventDailogVisible"
      [emailEventsFormData]="emailEventsFormData" [emailParameters]="emailParametersForAddEvents"
      (getEmailEvents)="fetchEmailEvents()"
    (onCloseEmailEventDailog)="onCloseEmailEventsDialog($event)"></email-events-dailog>
  }